import { toast } from "react-toastify";

export const scheduleFollowUpReminder = (reminder) => {
  if (!reminder?.dateTime) return;

  const reminderTime = new Date(reminder.dateTime).getTime();
  const now = Date.now();

  if (reminderTime <= now) return;

  const reminderKey = `reminder_${reminder.reminderId}`;

  // ❗ Prevent duplicate scheduling
  if (localStorage.getItem(reminderKey)) return;

  localStorage.setItem(reminderKey, "scheduled");

  const timeoutId = setTimeout(() => {
    toast.info(buildReminderMessage(reminder), {
      closeOnClick: true,
      position: "bottom-right",
      autoClose: false, // manual close (as per your preference)
    });
  }, reminderTime - now);

  return timeoutId;
};

const formatDateTime = (dateString) => {
  if (!dateString) return "";
  const [date, time] = dateString.split("T");
  const [year, month, day] = date.split("-");
  const [hours, minutes] = time?.split(":") || [];
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const buildReminderMessage = (reminder) => {
  const dateTime = formatDateTime(reminder.dateTime);

  let context = "General Reminder";

  if (reminder.lead) {
    context = `Lead: ${reminder.lead.name}`;
  } else if (reminder.inventory) {
    context = `Inventory: ${reminder.inventory.name}`;
  }

  return `⏰ Reminder\n\n${context}\n\n${reminder.text}\n\nAt: ${dateTime}`;
};
